import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router'
import { reducer as FlashReducer } from 'redux-flash';
import PromotionReducer from './PromotionReducer';
import SubmissionReducer from './SubmissionReducer';
import SupportReducer from './SupportReducer';

export default (history) => combineReducers({
  router: connectRouter(history),
  flash: FlashReducer,
  promotion: PromotionReducer,
  submission: SubmissionReducer,
  support: SupportReducer
});
